/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 流程版本指令模块
 */
angular.module('editPageProcessLineModule', []).directive('editPageProcessLine', [
    '$q',
    '$state',
    '$stateParams',
    '$window',
    'editingCenterService',
    'messagePublishService',
    function($q, $state, $stateParams, $window, editingCenterService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/processLine/processLine.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        records: {},
                        copyVersion: [],
                        version: [], // 流程展示数据
                    };
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                    };
                    $scope.status = {};
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    messagePublishService.subscribe(`${$scope.parentStatus.mediaName}VersionInit`, function() {
                        getVersion($scope.list.METADATAID);
                    }, $scope);
                }

                /**  流程版本开始 */

                /**
                 * [getVersion 获取流程版本]
                 *
                 * @param  {[type]}  id
                 *   [id description]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function getVersion(id) {
                    var deferred = $q.defer();
                    var metadataid = angular.isDefined(id) ? id : $stateParams.wzmetadataid;
                    metadataid = $stateParams.iwometadataid ? $stateParams.iwometadataid : metadataid;
                    editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                        function(data) {
                            $scope.data.version = data;
                            $scope.page = data.page;
                            $scope.data.copyVersion = data.copyArray;
                            $scope.status.hasTimeline = true;
                            $scope.data.lastVersionid = data.lastVersionid;
                            deferred.resolve();
                        },
                        function() {
                            deferred.resolve();
                        }
                    );
                    return deferred.promise;
                }

                /**
                 * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
                 * @param  {[type]}  key [description] 操作日志或流程版本的数据
                 * @return {Boolean}     [description]
                 */
                $scope.isShowVersion = function(key) {
                    if (key === undefined) {
                        return false;
                    } else {
                        for (var i in key) {
                            return true;
                        }
                        return false;
                    }
                };

                /**
                 * [getLoadMore description]操作日志加载更多
                 * @return {[type]} [description]
                 */
                $scope.getLoadMore = function() {
                    $scope.page.CURRPAGE++;
                    getVersion();
                };

                /**
                 * [getComment 获取评审意见]
                 *
                 * @param  {[type]}  id
                 *   [id description]
                 * @param  {[type]}  currPage
                 *   [currPage description]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function getComment(id, currPage) {
                    editingCenterService.getComment(id, currPage).then(function(data) {
                        $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                        $scope.data.comment.hasMore = data.hasMore;
                        for (var i in data.voiceObj) {
                            $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                        }
                    });
                }

                /**
                 * [getComment description]获取评审意见
                 * @return {[type]} [description]
                 */
                $scope.getLoadMoreComment = function() {
                    $scope.data.comment.currPage += 1;
                    getComment($stateParams.wzmetadataid, $scope.data.comment.currPage);
                };

                /**
                 * [openPersonalVersionTime description] 打开流程版本详情页
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.openPersonalVersionTime = function(item) {
                    var path = $scope.parentData.path[item.MEDIATYPE];
                    var params = {};
                    var objName = $scope.parentData.versionName[item.MEDIATYPE];
                    params[objName] = item.OBJECTVERSIONID;
                    params['metadataid'] = $state.params[$scope.parentStatus.trench];
                    item.url = $state.href(path, params);
                    var url = item.url;
                    $window.open(url);
                };
            },
        };
    },
]);
